import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { SecondPageIndexBase, UserService } from 'vnpost-shared';
import { LlbAddComponent } from '../add/add.component';
import { AppComponent } from '../../../app.component';
import { LlbEditComponent } from '../edit/edit.component';
import { LlbResetpasswdComponent } from '../resetpasswd/resetpasswd.component';
import { LlbImportComponent } from '../import/import.component';
import { UserTypeId } from '../../../config/enums';
import { UnitService } from '../../../core/services/unit-service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-llb-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class LlbListComponent extends SecondPageIndexBase implements OnInit {

  @ViewChild('pCreate', { static: false }) pCreate: LlbAddComponent;
  @ViewChild('pEdit', { static: false }) pEdit: LlbEditComponent;
  @ViewChild('pRestorePasswd', { static: false }) pRestorePasswd: LlbResetpasswdComponent;
  @ViewChild('pImport') pImport: LlbImportComponent;

  unitCode = this.currentUser?.unitCode;
  listUnit: { label: string; value: string }[] = [];
  formGroup: any;

  constructor(
    protected _injector: Injector,
    protected _userService: UserService,
    public app: AppComponent,
    private _unitService: UnitService,
  ) {
    super(_userService, _injector);
    this.formGroup = new UntypedFormGroup({
      query: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
    this.loadTableColumnConfig();
    this.getListUnit();
    this.getData();
    this.resetBulkSelect();
  }

  loadTableColumnConfig() {
    this.cols = [
      { field: 'llbCode', header: 'Mã CTV', visible: true, sort: true },
      { field: 'displayName', header: 'Họ và tên', visible: true, sort: true },
      { field: 'gender', header: 'Giới tính', visible: true, sort: true },
      { field: 'dateOfBirth', header: 'Ngày sinh', visible: true, sort: true },
      { field: 'phoneNumber', header: 'Số điện thoại', visible: true, sort: true },
      { field: 'unitCode', header: 'Đơn vị', visible: true, sort: true },
      { field: 'status', header: 'Trạng thái', visible: true, sort: true },
    ];
  }

  getListUnit() {
    this._unitService.getTreeUnitByUnitCode(this.currentUser?.unitCode).then((rs) => {
      if (rs.success) {
        this.listUnit = rs?.data
          ?.map((r) => ({
            label: `- ${r.unitName} (${r.unitCode})`,
            value: r.unitCode,
          }));
      } else {
        this.listUnit = [];
      }
    });
  }

  async getData() {
    this.isLoading = true;
    var model = {
      keyword: this.query,
      status: this.status,
      unitCode: this.unitCode,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      orderCol: this.orderCol,
      isDesc: this.isDesc,
      typeId: UserTypeId.LLB
    }
    await this._userService.find(model)
      .then(response => {
        this.dataSource = response.data;
        this.totalRecord = response.totalRecord;
        this.dataExport = response.data;
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        this._notifierService.showHttpUnknowError();
      });

    this.resetBulkSelect();
  }

  edit() {
    const item = this.selectedItems[0];
    this.pEdit.showPopup(item.id);
  }

  add() {
    this.pCreate.showPopup();
  }

  restorePasswd() {
    const item = this.selectedItems[0];
    this.pRestorePasswd.showPopup(item.id);
  }

  onImport() {
    this.pImport.showPopup();
  }
}
